import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import Dropdown from "./Dropdown";
import CustomLoader from "../static/CustomLoader";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterSearch,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const DropdownListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [loading, setLoading] = useState(false);
  const [accessData, setAccessData] = useState([{}]);
  const [filterData, setFilterData] = useState([{}]);
  const [serach, setSerach] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [density, setDensity] = useState("standard");
  const [showConfirm, setShowConfirm] = useState(false);
  const [editShow, setEditShow] = useState(false);

  const editHandleClose = () => {
    setShowConfirm(true);
  };

  const editHandleShow = () => {
    if (selectedData.length !== 1) {
      toast.warning("Please Select only one value");
      return;
    }
    setEditShow(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setEditShow(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  const columns = [
    {
      field: "fxid",
      headerName: "Code",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "comment",
      headerName: "Comment",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
  ];

  useEffect(() => {
    fetchData();
  }, [refresh]);

  const fetchData = async () => {
    try {
      setLoading(true);
      axios
        .get(apiUrl + "dropdown/distinct", { headers })
        .then((response) => {
          const data = response.data.map((item, index) => ({
            ...item,
            id: `${index}`,
          }));
          setAccessData(data);
          setFilterData(data);
          setRefresh(false);
          setSelectedData([]);
          setLoading(false);
        })
        .catch((error) => {
          console.log("error " + error);
          setAccessData([{}]);
          setLoading(false);
        });
    } catch (error) {
      setAccessData([{}]);
      setLoading(false);
    }
  };

  const handlesearch = (event) => {
    const getSearch = event.target.value.toLowerCase();
    if (getSearch.length > 0) {
      const searchdata = filterData.filter((item) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(getSearch),
        ),
      );
      setAccessData(searchdata);
    } else {
      setAccessData(filterData);
    }
    setSerach(getSearch);
  };

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <MasterButton
              variant="update"
              tooltip="Edit Selected Dropdown"
              onClick={editHandleShow}
              disabled={loading}
            >
              Update
            </MasterButton>
          }
          search={
            <MasterSearch
              tooltip="Search by All"
              value={serach}
              onChange={handlesearch}
              inputRef={(input) => input && input.focus()}
            />
          }
        />
        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={
            accessData !== null &&
            accessData.length > 0 &&
            Object.keys(accessData[0]).length !== 0 &&
            accessData
          }
          getRowId={(row) => row.fxid}
          columns={columns}
          onSelectionModelChange={(ids) => setSelectedData(ids)}
        />
      </MasterPage>

      {loading && <CustomLoader />}

      <MasterDialog
        open={editShow}
        onHide={editHandleClose}
        title="Edit Dropdowns"
        maxWidth="md"
      >
        <Dropdown
          selectedId={selectedData && selectedData[0]}
          mode="U"
          onHide={editHandleClose}
          setRefresh={setRefresh}
        />
      </MasterDialog>

      <MasterConfirmDialog
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};

export default DropdownListing;
